import Vue from 'vue'

export default {
  isLogin() {
    // get token from localStorage
    return localStorage.getItem('userData')
  },
  getUserData() {
    if (!this.isLogin()) return null

    return {
      data: localStorage.getItem('userData'),
      id: localStorage.getItem('userid'),
      email: localStorage.getItem('userEmail'),
      name: localStorage.getItem('userName'),
      avatar: localStorage.getItem('userAvatar'),
      image: localStorage.getItem('userAvatar'),
    }
  },
  setUserData(user) {
    localStorage.setItem('userData', true)
    localStorage.setItem('userid', user._id)
    localStorage.setItem('userEmail', user.email)
    localStorage.setItem('userName', user.fullName ? user.fullName : '')
    localStorage.setItem('userAvatar', user.image ? user.image : '')
    localStorage.setItem('typeOfProfile', user.typeOfProfile)    
  },
  cleanUserData() {
    localStorage.removeItem('userData')
    localStorage.removeItem('useradmin')
    localStorage.removeItem('userid')
    localStorage.removeItem('userEmail')
    localStorage.removeItem('userName')
    localStorage.removeItem('userAvatar')
  },
}



// WEBPACK FOOTER //
// ./src/services/auth.js